var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.68663 8.17801C5.9885 8.17801 4.6059 6.79541 4.6059 5.09728C4.6059 3.39914 5.9885 2.01655 7.68663 2.01655C9.38476 2.01655 10.7674 3.39914 10.7674 5.09728C10.7674 6.79541 9.38476 8.17801 7.68663 8.17801ZM7.68663 2.30995C6.15146 2.30995 4.89931 3.56211 4.89931 5.09728C4.89931 6.63244 6.15146 7.8846 7.68663 7.8846C9.2218 7.8846 10.474 6.63244 10.474 5.09728C10.474 3.56211 9.2218 2.30995 7.68663 2.30995Z",
    fill: "white",
    stroke: "#92ABFE",
    strokeWidth: 0.586806
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.7324 14.046C12.6538 14.046 12.5857 13.9779 12.5857 13.8993C12.5857 11.6541 10.323 9.93837 7.6917 9.93837C5.06039 9.93837 2.79774 11.6541 2.79774 13.8993C2.79774 13.9779 2.72959 14.046 2.65104 14.046C2.57249 14.046 2.50434 13.9779 2.50434 13.8993C2.50434 11.6045 4.77815 9.64497 7.6917 9.64497C10.6052 9.64497 12.8791 11.6045 12.8791 13.8993C12.8791 13.9779 12.8109 14.046 12.7324 14.046Z",
    fill: "white",
    stroke: "#92ABFE",
    strokeWidth: 0.586806
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.386c094b53911208099dd922780984f4.svg";
export { ForwardRef as ReactComponent };